<template>
  <main>
    <!--Broadrick Language-->
    <section v-if="apfConfig.apfLanguageTemplate.Broadrick?.includes(school)" class="Languages-container">
      <div style="margin-bottom: 1rem"><strong>Languages</strong></div>

      <div class="w-full">
        <label style="margin-bottom: 0; font-weight: bold">Mandarin Immersion Pathway (Acceptance is subjected to an assessment.)</label>
        <label>Applying for Mandarin Immersion Pathway?</label>
        <div class="input-group">
          <label class="radio-inline" style="margin-right: 1rem"> <input type="radio" v-model="bilingualYesNoValue" value="Yes" required />Yes </label>
          <label class="radio-inline"> <input type="radio" v-model="bilingualYesNoValue" value="No" required />No </label>
        </div>
      </div>

      <div class="w-full" v-if="bilingualYesNoValue === 'No'">
        <br />
        <label style="margin-bottom: 0">Additional Language (Integrated Curriculum Pathway only - please select one)</label>
        <label>
          If your answer is no to the above question, and your child has a strong command of the English Language, you may select one additional language from
          the following:
        </label>
        <div class="input-group">
          <label style="margin-right: 1rem" class="radio-inline" v-for="(lang, val) in languages" :key="val">
            <input type="radio" name="additionalLangValue" v-model="additionalLangValue" :value="val" required />{{ lang }}
          </label>
        </div>
      </div>

      <div class="w-full">
        <small
          >Note: Child with minimal English Language Proficiency is required to take English as an Additional Language (EAL). Your child may be required to take
          EAL lessons based on Teacher's recommendation. The School will undertake an assessment on your child's English acquisition to determine whether we are
          able to offer a curriculum to your child's needs</small
        >
      </div>
    </section>
    <!--Broadrick Language-->
    <!--Orchard Language-->
    <section v-if="apfConfig.apfLanguageTemplate.Orchard?.includes(school)" class="Languages-container">
      <div style="margin-bottom: 1rem"><strong>Languages</strong></div>

      <div class="w-full">
        <label style="margin-bottom: 0; font-weight: bold">Additional Language (Please select one)</label>
        <label>If your child has a strong command of the English Language, you may select one additional language from the following:</label>
        <div class="input-group">
          <label style="margin-right: 1rem" class="radio-inline" v-for="(lang, val) in languages" :key="val">
            <input type="radio" v-model="additionalLangValue" :value="val" required />{{ lang }}
          </label>
        </div>
        <div class="requiredFieldsMsg" v-if="validator.additionalLangValue.$error">
          <el-alert :title="getValidationMessageFromKey('additionalLangValue')" type="error"></el-alert>
        </div>
      </div>

      <div style="width: 100%">
        <small
          >Note: Child with minimal English Language Proficiency is required to take English as an Additional Language (EAL). Your child may be required to take
          EAL lessons based on Teacher's recommendation. The School may undertake an assessment on your child's English acquisition to determine whether we are
          able to offer a curriculum to your child's needs</small
        >
      </div>
    </section>
    <!--Orchard Language-->
    <!--PreSchool Language-->
    <section v-if="preschoolInfo && preschoolInfo.langState" class="Languages-container">
      <div class="w-full">
        <div v-if="preschoolInfo.langState.ddlLanguage">
          <div style="margin-bottom: 1rem">
            <strong>{{ preschoolInfo.langState.title }}</strong>
          </div>
          <div>
            <div class="input-group">
              <label style="margin-right: 1rem" class="radio-inline" v-for="(lang, val) in preschoolInfo.langState.ddlLanguage" :key="val">
                <input type="radio" v-model="langValue" :value="val" required />{{ lang }}
              </label>
            </div>
            <div class="requiredFieldsMsg" v-if="validator.langValue.$error">
              <el-alert :title="getValidationMessageFromKey('langValue')" type="error"></el-alert>
            </div>
          </div>
        </div>

        <div v-if="preschoolInfo.langState.ddlAddLanguage">
          <div v-if="preschoolInfo.langState && preschoolInfo.langState.additionalLangLabel">
            <label style="margin-bottom: 0; font-weight: bold">{{ preschoolInfo.langState.additionalLangLabel }}</label>
          </div>
          <div v-else>
            <label style="margin-bottom: 0; font-weight: bold">Additional Language (Please select if applicable)</label>
            <label>{{ preschoolInfo.langState.remark }}</label>
            <label>If your child has a strong command of the English Language, you may select one additional language from the following:</label>
          </div>
          <div>
            <div class="input-group" v-if="preschoolInfo">
              <el-checkbox-group v-model="selectedAddLanguage" :min="0" :max="10">
                <el-checkbox v-for="language in preschoolInfo.langState.ddlAddLanguage" :label="language" :key="language">{{ language }} </el-checkbox>
              </el-checkbox-group>
              <!--<label style="margin-right: 1rem;" class="radio-inline"
					             v-for="(lang, val) in preschoolInfo.langState.ddlAddLanguage" :key="val">
						      <input type="checkbox" v-model="additionalLangValue" :value="val"/>{{ lang }}
					      </label>-->
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%" v-if="!preschoolInfo.langState.hideEAL">
        <small
          >Note: Child with minimal English Language Proficiency is required to take English as an Additional Language (EAL). Your child may be required to take
          EAL lessons based on Teacher's recommendation. The School may undertake an assessment on your child's English acquisition to determine whether we are
          able to offer a curriculum to your child's needs</small
        >
      </div>
    </section>
    <!--PreSchool Language-->

    <!--MIS Language-->
    <section v-if="showEnglishProficiency" class="mis-lang">
      <div style="margin-bottom: 1rem"><strong>Languages</strong></div>
      <div style="margin-bottom: 0.5rem"><strong>* English Proficiency:</strong></div>
      <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 0.5rem">
        <strong style="width: 7rem">Reading:</strong>
        <label><input type="radio" name="english_reading" v-model="form.englishReading" value="Excellent" />Excellent</label>
        <label><input type="radio" name="english_reading" v-model="form.englishReading" value="Good" />Good</label>
        <label><input type="radio" name="english_reading" v-model="form.englishReading" value="Fair" />Fair</label>
        <label><input type="radio" name="english_reading" v-model="form.englishReading" value="Poor" />Poor</label>
        <div class="requiredFieldsMsg" v-if="validator.englishReading.$error">
          <el-alert :title="getValidationMessageFromKey('englishReading')" type="error"></el-alert>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 0.5rem">
        <strong style="width: 7rem">Writing:</strong>
        <label><input type="radio" name="english_writing" v-model="form.englishWriting" value="Excellent" />Excellent</label>
        <label><input type="radio" name="english_writing" v-model="form.englishWriting" value="Good" />Good</label>
        <label><input type="radio" name="english_writing" v-model="form.englishWriting" value="Fair" />Fair</label>
        <label><input type="radio" name="english_writing" v-model="form.englishWriting" value="Poor" />Poor</label>
        <div class="requiredFieldsMsg" v-if="validator.englishWriting.$error">
          <el-alert :title="getValidationMessageFromKey('englishWriting')" type="error"></el-alert>
        </div>
      </div>

      <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 0.5rem">
        <strong style="width: 7rem">Speaking:</strong>
        <label><input type="radio" name="english_speaking" v-model="form.englishSpeaking" value="Excellent" />Excellent</label>
        <label><input type="radio" name="english_speaking" v-model="form.englishSpeaking" value="Good" />Good</label>
        <label><input type="radio" name="english_speaking" v-model="form.englishSpeaking" value="Fair" />Fair</label>
        <label><input type="radio" name="english_speaking" v-model="form.englishSpeaking" value="Poor" />Poor</label>
        <div class="requiredFieldsMsg" v-if="validator.englishSpeaking.$error">
          <el-alert :title="getValidationMessageFromKey('englishSpeaking')" type="error"></el-alert>
        </div>
      </div>

      <div style="margin-top: 1rem" v-if="languages">
        <div style="margin-bottom: 0.5rem">
          <strong>* If your child is not required to take EAL lessons, they may select one additional language from the following:</strong>
          <strong v-if="group === 'MIS'"
            ><br />For Grade 1 applications all student must select a second language, please ensure this has been completed.</strong
          >
        </div>
        <div class="input-group">
          <label style="margin-right: 1rem" class="radio-inline" v-for="(lang, val) in languages" :key="val">
            <input type="radio" name="additionalLangValue" v-model="form.additionalLangValue" :value="val" required />{{ lang }}
          </label>
        </div>
      </div>
    </section>
    <!--MIS Language-->
  </main>
</template>

<script>
import { schools, middletonSchools, preSchoolsDropdown } from '@/pages/application/data'
import { getValidationMessageFromKey } from '../data.js'
import apfConfig from '@/pages/application/config/apfConfig'

export default {
  props: ['form', 'group', 'school', 'validator', 'preschoolInfo', 'bilingualYesNoValue', 'langValue', 'additionalLangValue', 'englishSpeaking'],
  data() {
    return {
      schools,
      middletonSchools,
      preSchoolsDropdown,
      apfConfig,
      selectedAddLanguage: [],
    }
  },
  mounted() {
    if (this.preschoolInfo) {
      this.selectedAddLanguage = this.form.additionalLangValue
    }
  },
  watch: {
    selectedAddLanguage: function (val) {
      if (this.preschoolInfo) {
        this.$emit('selectedAddLanguage', val)
      }
    },
    additionalLangValue: function (val) {
      this.$emit('additionalLangValue', val)
    },
  },
  methods: { getValidationMessageFromKey },
  computed: {
    isMis() {
      return this.group === 'MIS'
    },

    isEIS() {
      return this.group === 'EIS'
    },

    showEnglishProficiency() {
      return this.isMis || this.isEIS
    },

    languages() {
      switch (this.school) {
        case schools['Broadrick']:
          return {
            Mandarin: 'Mandarin',
            Japanese: 'Japanese (Native Speaker)',
            Hindi: 'Hindi (Native Speaker)',
          }
        case schools['Orchard']:
          return {
            Mandarin: 'Mandarin',
            Japanese: 'Japanese',
            Spanish: 'Spanish (Secondary Only)',
          }
        case middletonSchools['Tampines']:
          return {
            Mandarin: 'Mandarin',
            French: 'French',
            Hindi: 'Hindi',
          }
        case middletonSchools['West Coast']:
          return {
            Mandarin: 'Mandarin',
            Japanese: 'Japanese',
          }
        default:
          return null
      }
    },
  },
}
</script>

<style scoped>
.mis-lang label {
  margin-bottom: 0;
  font-weight: normal;
}

label input {
  margin-right: 0.3rem;
  transform: translateY(2px);
}
</style>
